<template>
    <HelpPopup icon="fa fa-info-circle" :muted="false" :icon-muted="true" placement="left">
        <template #label>
            <span class="mr-1">
                {{ pharmacyTypeLabel }}
            </span>
        </template>
        <div class="d-flex flex-column">
            <div v-if="pharmacy?.businessName">
                <strong>
                    {{ pharmacy.businessName }}
                </strong>
            </div>
            <div>
                {{ pharmacy.address.addressLine1 }}
                <br>
                <template v-if="pharmacy.address.addressLine2">
                    {{ pharmacy.address.addressLine2 }}
                    <br>
                </template>
                {{ pharmacy.address.city + "," }}
                {{ pharmacy.address.stateProvince }}
                {{ pharmacy.address.postalCode }}
            </div>
            <div v-if="npi">
                NPI: {{ npi }}
            </div>
            <div v-if="primaryTelephone">
                Phone: {{ primaryTelephone.number }}
            </div>
        </div>
    </HelpPopup>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import HelpPopup from '@/components/HelpPopup.vue';

@Component({
    name: "RTPBType",
    components: {
        HelpPopup
    }
})
export default class RTPBType extends Vue {
    @Prop({ required: true }) protected pharmacy!: any;

    get pharmacyTypeLabel(): string {
        const labels: { [key: number]: string } = {
            0: "Retail",
            1: "Mail",
            2: "90 Day at Retail",
            3: "Specialty"
        };
        return labels[this.pharmacy.pharmacyType] || "Unknown";
    }

    get primaryTelephone() {
        return this.pharmacy.communicationNumbers?.primaryTelephone;
    }

    get npi() {
        return this.pharmacy?.identification?.npi;
    }
}

</script>

<style scoped>
div.d-flex {
    gap: 5px;
}
</style>